module.exports = __webpack_public_path__ + "static/media/swift.598cebe1.jpg";